import React from 'react'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import qs from 'qs'
import { connect } from 'react-redux'
import { FormCell, CellHeader, Label, CellBody, Input, CellsTitle, TextArea, Toast, Dialog } from 'react-weui'
import { browserHistory } from 'react-router'
import {isLZWKAPP} from '../../utils'
import { updateSuccess } from '../../utils/connectApp'
import { Header, BottomBtn } from '../../components/liveroomLecturer'
import { Page, WKError } from '../../components'
import '../../css/page/LiveroomLecturerPage.css'
import { httpCatch } from '../../actions/liveroomSettingLecture'
import errorImg from '../../images/no-source.png'


class VipPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            amount: '',
            percent: '',
            desc: '',
            isPending: false,
            pendingText: '',
            isSuccess: false,
            isError: false,
            alert: {
                isAlert: false,
                alertMsg: '',
            },
        }
    }
    componentDidMount() {
        // document.querySelector('#vip-amount').focus()
        document.title = 'VIP会员设置';

        //风控
        this.page.showFengKongTip()

        const liveroomId = this.props.params.liveroom_id
        axios.get(`/api/liveroom/${liveroomId}/edit_info`)
            .then(res => {
                if (!res.data.data.liveroom.vip_info) {
                    return this.setState({ isPending: false })
                }
                this.setState({
                    amount: res.data.data.liveroom.vip_info.vip_fee / 100,
                    percent: res.data.data.liveroom.vip_info.vip_resell_persent,
                    desc: res.data.data.liveroom.vip_info.vip_desc,
                    isPending: false,
                })
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    this.setState({ isError: true })
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出问题了。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_main_404',
                            btn: '去首页看看'
                        }
                    })
                    return
                }
                if (error.response && error.response.status === 403) {
                    this.setState({ isError: true })
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '你没有查看权限。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_main_403',
                            btn: '去首页看看'
                        }
                    })
                }
            })
    }
    onSubmit(e) {
        e.preventDefault()
        const liveroomId = this.props.params.liveroom_id
        const amount = +String(this.state.amount).trim()
        const percent = +String(this.state.percent).trim()
        const desc = String(this.state.desc).trim()
        const verifyRes = this.verify(amount, percent, desc)
        if (!verifyRes.status) {
            this.setState({ alert: { isAlert: true, alertMsg: verifyRes.msg } })
            return
        }
        this.setState({ isPending: true, pendingText: '正在提交' })
        axios.post(`/api/liveroom/${liveroomId}/edit`, qs.stringify({
            vip_fee: (amount * 100).toFixed(),
            vip_fee_desc: desc,
            vip_resell_percent: percent,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.setState({ alert: { isAlert: true, alertMsg: res.data.msg } })
                }
                // 通知app更新页面信息
                updateSuccess({ type: 'liveroom' })
                this.setState({ isSuccess: true })

                setTimeout(() => {
                    this.setState({ isSuccess: false })
                    // browserHistory.go(-1)
                    if (isLZWKAPP()) {
                        browserHistory.go(-1)
                        // location.assign(`lizhiweike://liveroom?liveroom_id=${liveroomId}`)
                    } else {
                        // browserHistory.go(-1)
                        location.assign(`/liveroom/vip?liveroom_id=${this.props.params.liveroom_id}`)
                    }
                }, 1000)
            })
    }
    verify(amount, percent, desc) {
        if (!/^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/.test(amount) || amount < 0) {
            return {
                status: false,
                msg: '请输入正确的价格',
            }
        }
        if (!/^\d+$/.test(percent) || (percent < 0 || percent > 100)) {
            return {
                status: false,
                msg: '百分比为0到49的整数',
            }
        }
        if (desc === '') {
            return {
                status: false,
                msg: '描述不可为空',
            }
        }
        return { status: true }
    }
    bindValue(e, type) {
        this.setState({ [type]: e.target.value })
    }
    render() {
        if (this.state.isError) {
            return <div style={{ background: '#fff', position: 'fixed', width: '100%', height: '100%' }}>
                <WKError />
            </div>
        }
        return (
            <div className="liveroom-setting-vip">
                <Page parent={this}>
                    <Header title='VIP会员设置' />
                    <form>
                        <div className="form-content">
                            <FormCell>
                                <CellHeader>
                                    <Label>会员价格</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input value={this.state.amount} onChange={e => this.bindValue(e, 'amount')} type="text"
                                        placeholder="请输入价格（元）" id='vip-amount'
                                    />
                                </CellBody>
                            </FormCell>
                            <FormCell>
                                <CellHeader>
                                    <Label>分销比例</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input value={this.state.percent} onChange={e => this.bindValue(e, 'percent')} type="text"
                                        placeholder="请输入分销比例（%）"
                                    />
                                </CellBody>
                            </FormCell>
                            <FormCell className='textarea'>
                                <div className="textarea-title">VIP会员描述</div>
                                <CellBody>
                                    <TextArea showCounter={false} value={this.state.desc} onChange={e => this.bindValue(e, 'desc')} placeholder="请输入描述" rows="4"></TextArea>
                                </CellBody>
                            </FormCell>
                        </div>
                        <div className="intro">
                            <p>开启VIP会员说明</p>
                            <p>1. 成功购买VIP会员的用户即可享受当前直播间内的所有专栏和课程（转载专栏和转载课程除外）；</p>
                            <p>2. 价格设置0元即可关闭此功能；</p>
                            <p>3. VIP会员有效期为一年；</p>
                            <p>4. 若VIP会员功能关闭，购买VIP会员的用户依然享有VIP服务，直到服务到期；</p>
                            <p>5. 分销比例设置范围为0～49%，设置为0代表关闭分销；</p>
                        </div>
                        <BottomBtn btnContent={{ text: '确定', method: e => this.onSubmit(e) }} />
                    </form>
                    <Toast icon="loading" show={this.state.isPending}>{this.state.pendingText || '正在获取数据'}</Toast>
                    <Toast icon="success-no-circle" show={this.state.isSuccess}>修改成功</Toast>
                    <Dialog type="ios" title='温馨提示' show={this.state.alert.isAlert} buttons={[{
                        label: '确定',
                        onClick: () => this.setState({ alert: { isAlert: false } }),
                    }]}>
                        {this.state.alert.alertMsg}
                    </Dialog>
                </Page>
            </div>
        )
    }
}

export default connect(null)(VipPage)



// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/VipPage.js